import { createSelector } from "reselect";
const createSelectors = (parentReducer) => {
    return new (class {
        selectJobActiveAllID = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["JobPackWrapper_reducer"];
            return reducer.jobPackId;
        };
        selectJobPackCount = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["JobPackWrapper_reducer"];
            return reducer.jobpackCount;
        };

        selectJobPendingAllID = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["JobPackWrapper_reducer"];
            return reducer.jobPendingId;
        };
        selectAllUsers = (store) => {
            const reducer = store["MainReducer"];
            return reducer.users;
        };
        selectAllToolboxes = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["JobPackWrapper_reducer"];
            return reducer.toolboxes;
        };
        selectAllQualifications = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["JobPackWrapper_reducer"];
            return reducer.allQualifications;
        };
        selectJobArchivedAllID = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["JobPackWrapper_reducer"];
            return reducer.jobArchivedId;
        };
   
        selectNewJobPackUID = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["JobPackWrapper_reducer"];
            return reducer.newJobPackUID;
        };
        selectJobPack = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["JobPackWrapper_reducer"];
            return reducer.jobPack;
        };
        selectJobTypes = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["JobPackWrapper_reducer"];
            return reducer.jobTypes;
        };
        selectedJobType = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["JobPackWrapper_reducer"];
            return reducer.selectedJobType;
        };
        selectProfile =  store  => {
            const reducer = store["UserProfile_reducer"];
            if (reducer.profile) return reducer.profile.profile;
            else return false;
        };
       selectRequesting = (store) => {
        const pageReducer = store[parentReducer];
        const reducer = pageReducer["JobPackWrapper_reducer"];
        return reducer.requesting;
        }
        selectJobPackProfile = createSelector(
            [this.selectJobPack],
            (jobPack = false) => {
                if (jobPack) {
                    return jobPack.profile;
                } else return false;
            }
        );
        selectJobPackAllIds = createSelector(
            [this.selectJobActiveAllID],
            (id = false) => {
                if (id) {
                    let activeIds = Object.keys(id).map((e) => {
                        return e;
                    });
                    return activeIds;
                } else return false;
            }
        );
        selectJobPackPendingAllIds = createSelector(
            [this.selectJobPendingAllID],
            (id = false) => {
                if (id) {
                    let pendingIds = Object.keys(id).map((e) => {
                        return e;
                    });
                    return pendingIds;
                } else return false;
            }
        );
        selectJobPackArchivedIds = createSelector(
            [this.selectJobArchivedAllID],
            (id = false) => {
                if (id) {
                    let archiveIds = Object.keys(id).map((e) => {
                        return e;
                    });
                    return archiveIds;
                } else return false;
            }
        );
    })();
};

export default createSelectors;
